import { computed, ref, watch, watchEffect } from 'vue'

const STORE_KEY = 'traint_workout_values'

interface StoredWorkoutValues {
  exercises: number
  work: number
  rest: number
}

const exercises = ref(1)
const work = ref(10)
const rest = ref(5)

export function useTimer () {
  const vals = getValues()
  exercises.value = vals.exercises
  work.value = vals.work
  rest.value = vals.rest

  const totalTime = computed(() => {
    return exercises.value * (work.value + rest.value)
  })

  const totalTimeMs = computed(() => totalTime.value * 1000)
  const workMs = computed(() => work.value * 1000)
  const restMs = computed(() => rest.value * 1000)

  function time2Str (seconds:number) {
    const m = Math.floor(seconds / 60)
    const s = Math.ceil(seconds % 60)
    return `${m}:${s.toString().padStart(2, '0')}`
  }

  function getValues (): StoredWorkoutValues {
    const vals = localStorage.getItem(STORE_KEY)
    if (vals) {
      return JSON.parse(vals) as StoredWorkoutValues
    }
    return {
      exercises: 1,
      work: 20,
      rest: 10
    }
  }

  function saveValues () {
    localStorage.setItem(STORE_KEY, JSON.stringify({
      exercises: exercises.value,
      work: work.value,
      rest: rest.value
    }))
  }

  watch(exercises, saveValues)
  watch(work, saveValues)
  watch(rest, saveValues)

  return {
    exercises,
    work,
    rest,
    totalTime,
    workMs,
    restMs,
    totalTimeMs,
    time2Str
  }
}
